import Vue, { reactive } from 'vue';
import type { Store } from 'vuex';
import type { AccountUser } from '@travelata-libs/travelata-frontend';
import account from '@/js/desktop/components/account';
import eventBus from '@ve/services/eventBus';
import getStore from '@ve/services/getStore/getStore';

import LibTourPageHeader from '../ui/LibTourPageHeader.vue';

declare let window: any;
const HOST_ANCHOR_SELECTOR = '#js-lib-tour-page-header-host';

export interface MountLibTourPageHeaderOptions {
    store?: Store<unknown>;
}

interface TourPageHeaderAuthData {
    user: AccountUser | null;
    accountUrl: string;
}


export function mountLibTourPageHeader(options: MountLibTourPageHeaderOptions = {}) {
    const anchor = typeof document === 'undefined' ? null : document.querySelector(HOST_ANCHOR_SELECTOR);
    if (!anchor) {
        return;
    }

    const store = options.store ?? getStore();

    const authData = reactive<TourPageHeaderAuthData>({
        user: null,
        accountUrl: window.appConfig.accountUrl,
    });

    eventBus.$on('authorize', (user: AccountUser) => {
        authData.user = user
    })


    new Vue({
        name: 'LibTourPageHeaderRoot',
        store,
        render: (createElement) => createElement(LibTourPageHeader, {
            props: { authData },
            on: {
                login: () => account.topMenuBar.openAuthForm(),
                logout: () => {
                    authData.user = null;
                    account.topMenuBar.logout();
                },
            },
        }),
    }).$mount(anchor as Element);
}
